import { all, takeEvery, put, fork, call, select } from 'redux-saga/effects';
import { message } from 'antd';
import actions from './actions';
import { ApiClient } from '../../../api';
import { makeSelectPageToken } from '../../socialPage/selector';
import config from '../../../settings';

// Create selectors once for optimal performance
const selectPageToken = makeSelectPageToken();

function* getPageMembershipsSaga() {
  yield takeEvery(actions.GET_PAGE_MEMBERSHIPS, function*({ options }) {
    try {
      // Use pageToken for Page Admin operations (page memberships management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.getPageMemberships(options));
      if (response.success) {
        yield put(actions.getPageMembershipsSuccess(response.data, response.pagination));
      } else {
        yield put(actions.getPageMembershipsError(response.message || 'Failed to fetch page memberships'));
        message.error('Failed to fetch page memberships');
      }
    } catch (error) {
      yield put(actions.getPageMembershipsError(error.message));
      message.error(`Error fetching page memberships: ${error.message}`);
    }
  });
}

function* createPageMembershipSaga() {
  yield takeEvery(actions.CREATE_PAGE_MEMBERSHIP, function*({ membershipData }) {
    try {
      // Use pageToken for Page Admin operations (page memberships management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.createPageMembership(membershipData));
      if (response.success) {
        yield put(actions.createPageMembershipSuccess(response.data));
        message.success('Page membership created successfully');
      } else {
        yield put(actions.createPageMembershipError(response.message || 'Failed to create page membership'));
        message.error('Failed to create page membership');
      }
    } catch (error) {
      yield put(actions.createPageMembershipError(error.message));
      message.error(`Error creating page membership: ${error.message}`);
    }
  });
}

function* updatePageMembershipSaga() {
  yield takeEvery(actions.UPDATE_PAGE_MEMBERSHIP, function*({ membershipId, membershipData }) {
    try {
      // Use pageToken for Page Admin operations (page memberships management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.updatePageMembership(membershipId, membershipData));
      if (response.success) {
        yield put(actions.updatePageMembershipSuccess(response.data));
        message.success('Page membership updated successfully');
      } else {
        yield put(actions.updatePageMembershipError(response.message || 'Failed to update page membership'));
        message.error('Failed to update page membership');
      }
    } catch (error) {
      yield put(actions.updatePageMembershipError(error.message));
      message.error(`Error updating page membership: ${error.message}`);
    }
  });
}

function* deletePageMembershipSaga() {
  yield takeEvery(actions.DELETE_PAGE_MEMBERSHIP, function*({ membershipId }) {
    try {
      // Use pageToken for Page Admin operations (page memberships management)
      const pageToken = yield select(selectPageToken);
      const apiClient = new ApiClient(config.apiUrl, pageToken);
      const response = yield call(() => apiClient.deletePageMembership(membershipId));
      if (response.success) {
        yield put(actions.deletePageMembershipSuccess(membershipId));
        message.success('Page membership deleted successfully');
      } else {
        yield put(actions.deletePageMembershipError(response.message || 'Failed to delete page membership'));
        message.error('Failed to delete page membership');
      }
    } catch (error) {
      yield put(actions.deletePageMembershipError(error.message));
      message.error(`Error deleting page membership: ${error.message}`);
    }
  });
}

export default function* pageMembershipsSaga() {
  yield all([
    fork(getPageMembershipsSaga),
    fork(createPageMembershipSaga),
    fork(updatePageMembershipSaga),
    fork(deletePageMembershipSaga),
  ]);
}
